//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.CutPatternBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../CAM/CAM.InheritableIntBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
let d=[[[0,"AddCenterPasses",1,0],[0,"CutBetweenLevels",1,0],[0,"CutLevelType",1,0],[1,"CutPattern",0,"CAM.CutPatternBuilder",0],[1,"DepthPerCut",0,"CAM.StepoverBuilder",0],[0,"FlowCutDirection",1,0],[1,"NumberOfStepoversPerSide",0,"CAM.InheritableIntBuilder",0],[1,"OverlapDistanceBuilder",0,"CAM.InheritableToolDepBuilder",0],[0,"PatternDirection",1,0],[0,"Sequence",0,"CAM.Sequence",0],[0,"SteepCutDirection",1,0],[1,"Stepover",0,"CAM.StepoverBuilder",0]],[],[]];
SPLM.CAM.FlowCutSteepContainment = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FlowCutSteepContainment";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FlowCutSteepContainment.PatternDirectionTypes = Object.freeze({
    "Outward" : "Outward", "Inward" : "Inward"});

SPLM.CAM.FlowCutSteepContainment.CutDirectionTypes = Object.freeze({
    "Mixed" : "Mixed", "Climb" : "Climb", "Conventional" : "Conventional"});

SPLM.CAM.FlowCutSteepContainment.SteepCutDirectionTypes = Object.freeze({
    "Mixed" : "Mixed", "HighToLow" : "HighToLow", "LowToHigh" : "LowToHigh"});

SPLM.CAM.FlowCutSteepContainment.CutLevelTypes = Object.freeze({
    "Constant" : "Constant", "Optimized" : "Optimized"});

export default SPLM;